import { useEffect } from "react";
import { useLocation, useHistory } from 'react-router-dom';

import _ from 'lodash';

import { PUBLISHING_LIVE_ELEMENT_SUCCEEDED, AUTO_SAVING_PAGE_SUCCEEDED, UPDATING_PAGE_SUCCEEDED, PUBLISHING_PALETTE_COMPONENT_SUCCEEDED, CREATING_EDITOR_BRAND_MEDIA_SUCCEEDED, CREATING_EDITOR_BRAND_COMPONENT_SUCCEEDED } from "constants/actionTypes";

import { useDispatch } from "react-redux";
import { reloadLiveElementOnChange } from "actions/live_elements";
import { reloadEditorBrandSucceed, reloadPaletteComponentOnChange } from "actions/brandKit/components";

const broadcastChannel = new BroadcastChannel("cleverstory-channel");

const broadcastMessage = (message) => {
  if(broadcastChannel){
    broadcastChannel.postMessage(message);
  }
}

const BroadcastChannelComponent = () => {
  const dispatch = useDispatch();
  
  const location = useLocation();

  const handleMessages = (e) => {
    const data = _.get(e, 'data');

    if(!data){
      return;
    }

    const { type, payload } = data;

    switch(type){
      case PUBLISHING_LIVE_ELEMENT_SUCCEEDED: {
        dispatch(reloadLiveElementOnChange(payload.response));
        break;
      }

      case PUBLISHING_PALETTE_COMPONENT_SUCCEEDED: {
        dispatch(reloadPaletteComponentOnChange(payload.response));
        break;
      }

      case AUTO_SAVING_PAGE_SUCCEEDED: 
      case UPDATING_PAGE_SUCCEEDED: {
        refreshPreviewPage(payload.id);
        break;
      }

      case CREATING_EDITOR_BRAND_COMPONENT_SUCCEEDED:
      case CREATING_EDITOR_BRAND_MEDIA_SUCCEEDED:
        dispatch(reloadEditorBrandSucceed(payload.brandkitId, payload.response, payload.type));
        break;

      default:
        return;
    }

  }

  useEffect(() => {
    broadcastChannel.onmessage = handleMessages;

    return () => {
      broadcastChannel.close();
    }
  }, []);

  const refreshPreviewPage = (page) => {
    const url = location.pathname;

    const match = url.match(/\/pages\/([^/]+)\/preview/);

    if (match && match[1] && match[1] === page) {
      window.location.reload(true);
    }
  }


  return false;
}

export { BroadcastChannelComponent, broadcastMessage };